'use strict';

import getNgModule from "getNgModule";
const ngModule = getNgModule(__filename);

ngModule.directive("observatoireTopBar", function() {
    return {
        restrict: 'E',
        replace: true,
        transclude : true,
        template : require("./observatoireTopBar.html"),
        controller : function($scope, security) {
            $scope.exit = function() {
                security.exit();
            };

        }
    };
});


// WEBPACK FOOTER //
// ./src/apps/observatoire/ng/structure/observatoireTopBar.js